import { useEffect } from 'react';

/**
 * 在每个页面设置独立的 title 与 meta description（SPA 站内 SEO）。
 * React 19 兼容实现，不使用 react-helmet。
 */
export default function usePageMeta(title: string, description: string) {
  useEffect(() => {
    document.title = title;
    let desc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!desc) {
      desc = document.createElement('meta');
      desc.setAttribute('name', 'description');
      document.head.appendChild(desc);
    }
    desc.setAttribute('content', description);
  }, [title, description]);
}